module.exports = __webpack_public_path__ + "img/20180815_151538_151.e28ded0e.jpg";